import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  fileCard: {
    padding: '12px 16px',
    borderRadius: '6px',
    marginBottom: '8px',
    backgroundColor: theme.palette.white,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',

    ':hover': {
      backgroundColor: theme.palette.neutralLighterAlt,
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  },
  container: {
    height: 'calc(100vh - 150px)',
    overflow: 'auto',
    paddingBottom: 200,
  },
}));
